import React, { useEffect, useState } from 'react';
import './Ordenes.report.generation.download.scss';

interface DownloadProps {
    reportMatrix: string[][];
    header: string[];
    reportName: string;
}

function OrderGenerationDownload({ reportMatrix, header, reportName }: DownloadProps) {
    const [csvFile, setCsvFile] = useState(null);

    useEffect(() => {
        if (!!reportMatrix[0] && reportMatrix[0].length && header.length) {
            const csvHead = header.map((h) => h).join(',');
            const csvBody = reportMatrix.map((row) => {
                return row.join(',')
            })
            const universalBOM = "\uFEFF";
            const csv = [csvHead].concat(csvBody).join('\n');
            const blob = new Blob([universalBOM+csv], { type: 'text/csv;charset=utf-8;' });
            setCsvFile(URL.createObjectURL(blob));
        } else {
            setCsvFile(null);
        }
    }, [reportMatrix, header]);

    if (!csvFile) {
        return (
            <span className="_downloadCsvIcon disabled">
                <span className="material-icons">
                    get_app
                </span>
            </span>
        )
    }
    return (
        <a className="_downloadCsvIcon" href={csvFile} download={`Pedidos_${reportName}_${new Date().toDateString()}.csv`}>
            <span className="material-icons">
                get_app
            </span>
        </a>
    )
}

export default OrderGenerationDownload;